import { immediateToast } from "izitoast-react";
import "izitoast-react/dist/iziToast.css";

export const handleToastMessage = (type, message,timeout=5000) => {
  // eslint-disable-next-line default-case
  switch (type) {
    case "info":
      immediateToast("info", {
        position: "topRight",
        message,
        timeout
      });
      break;
    case "success":
      immediateToast("success", {
        position: "topRight",
        message,
        timeout
      });
      break;
    case "warning":
      immediateToast("warning", {
        position: "topRight",
        message,
        timeout
      });
      break;
    case "error":
      immediateToast("error", {
        position: "topRight", // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
        message,
        timeout
      });
      break;
  }
};
